export default __webpack_public_path__ + "static/media/3R.01e98a85.png";